import React from 'react';
import BaseTimelineRecordLayout from 'domain/shared/timeline/layout/BaseTimelineRecordLayout';
import { useListContext } from 'framework/list';
import { TimelineContextData } from 'framework/ui/timeline';
import { useShowContext } from 'framework/show';
import { useParams } from 'react-router-dom';
import { DeleteTimelineRecordButton, EditTimelineRecordButton } from 'domain/shared/timeline/button';
import { PinTimelineButton } from 'domain/shared/timeline';
import useCrmStrategyNoteService, {
  CRMTimelineType,
  DELETE_STRATEGY_NOTE_PERMISSION,
  READ_STRATEGY_NOTE_PERMISSION,
  UPDATE_STRATEGY_NOTE_PERMISSION,
} from './crmStrategyNoteService';
import StrategyNoteContext from './StrategyNoteContext';

interface StrategyNoteTimelineRecordLayoutProps {
  onEdit: () => void;
  isPinned?: boolean;
  [key: string]: unknown;
}

const StrategyNoteTimelineRecordLayout = ({ onEdit, isPinned, ...props }: StrategyNoteTimelineRecordLayoutProps) => {
  const { id: accountId } = useParams<Dictionary<string>>();
  const { deleteById } = useCrmStrategyNoteService();
  const { data } = useShowContext();
  const id = data.getValueBySource('id');
  const timelineId = data.getValueBySource('timelineId');
  const { updateInList, pinTimelineAction }: TimelineContextData = useListContext();

  const buttons = [
    <EditTimelineRecordButton permissionToCheck={UPDATE_STRATEGY_NOTE_PERMISSION} key="edit" onEdit={onEdit} />,
    <DeleteTimelineRecordButton
      permissionToCheck={DELETE_STRATEGY_NOTE_PERMISSION}
      deleteMethod={deleteById}
      key="delete"
      id={id}
      timelineId={timelineId}
      entityName="strategy"
    />,
  ];

  return (
    <StrategyNoteContext id={id}>
      <BaseTimelineRecordLayout
        actions={[
          <PinTimelineButton
            key="pin"
            pinStatus={Boolean(isPinned)}
            pinMethod={async () => {
              if (!accountId || !pinTimelineAction || !updateInList) {
                return null;
              }

              const response = await pinTimelineAction(accountId, timelineId, !isPinned);
              updateInList(response?.id, response);
              return response;
            }}
          />,
        ]}
        actionName=""
        permissionToCheck={READ_STRATEGY_NOTE_PERMISSION}
        timelineType={CRMTimelineType.STRATEGY}
        buttons={buttons}
        {...props}
      />
    </StrategyNoteContext>
  );
};

export default StrategyNoteTimelineRecordLayout;
